import React, { useRef, useState } from 'react';
import { StarIcon, ReplyIcon, ArchiveIcon } from 'lucide-react';
import { gmailReviews } from '../data/content';
export function GmailReviews() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const handleScroll = () => {
    const el = trackRef.current;
    if (!el) return;
    const index = Math.round(el.scrollLeft / el.clientWidth);
    setActive(Math.max(0, Math.min(gmailReviews.length - 1, index)));
  };
  const goTo = (i: number) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollTo({
      left: i * el.clientWidth,
      behavior: 'smooth'
    });
  };
  return <section className="py-8" aria-label="Reseñas recibidas por correo" data-id="element-116" data-mp="e6gycadk60pr">
      <p className="mb-4 px-5 text-center text-[12px] font-semibold uppercase tracking-widest text-[#6f8f7c]" data-id="element-117" data-mp="j4s9coflah9k">
        Lo que nos llega al correo · desliza para ver más
      </p>

      <ul ref={trackRef} onScroll={handleScroll} className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-118" data-mp="1bmcxbe6o6xma">
        {gmailReviews.map(r => <li key={r.email} className="w-[calc(100%-0.75rem)] shrink-0 snap-center overflow-hidden rounded-2xl border border-[#dcdcdc] bg-white shadow-sm" data-id="element-119" data-mp="36g009u6veyvv">
            <div className="flex items-center justify-between border-b border-[#eee] px-3 py-2" data-id="element-120" data-mp="3fdaftrqq1a6l">
              <span className="text-[11px] font-semibold tracking-wide text-[#5f6368]" data-id="element-121" data-mp="3u26j7bhu1z0v">Recibidos</span>
              <div className="flex items-center gap-2 text-[#9aa0a6]" aria-hidden="true" data-id="element-122" data-mp="3p4ddskoct91n">
                <ArchiveIcon className="h-3.5 w-3.5" data-id="element-123" data-mp="6yi8tcxrcd55" />
                <ReplyIcon className="h-3.5 w-3.5" data-id="element-124" data-mp="2071b8uxqeq3" />
                <StarIcon className="h-3.5 w-3.5 fill-[#f4b400] text-[#f4b400]" data-id="element-125" data-mp="20qgiht7ap0f" />
              </div>
            </div>

            <div className="flex gap-3 p-3" data-id="element-126" data-mp="28s82axzzntn8">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[15px] font-semibold text-white ${r.color}`} aria-hidden="true" data-id="element-127" data-mp="23s3h4uo4yaqo">
                {r.initial}
              </div>
              <div className="min-w-0 flex-1" data-id="element-128" data-mp="cp3a3g5219c5">
                <div className="flex items-baseline justify-between gap-2" data-id="element-129" data-mp="hlabqwqf3yoa">
                  <p className="truncate text-[13px] font-bold text-[#202124]" data-id="element-130" data-mp="loge3taet5ph">{r.sender}</p>
                  <span className="shrink-0 text-[11px] text-[#5f6368]" data-id="element-131" data-mp="qnjidbikf7we">{r.time}</span>
                </div>
                <p className="truncate text-[11px] text-[#5f6368]" data-id="element-132" data-mp="vll3e1zjxhai">{r.email}</p>
                <p className="mt-1.5 text-[13px] font-semibold text-[#202124]" data-id="element-133" data-mp="10d320je3r5sb">{r.subject}</p>
                <p className="mt-1 text-[13px] leading-relaxed text-[#3c4043]" data-id="element-134" data-mp="15bxt08m840ni">{r.body}</p>
              </div>
            </div>
          </li>)}
      </ul>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-135" data-mp="19f3uz42az5o6">
        {gmailReviews.map((r, i) => <button key={r.email} type="button" onClick={() => goTo(i)} aria-label={`Ver reseña ${i + 1} de ${gmailReviews.length}`} aria-current={active === i} className={`h-2 rounded-full transition-all ${active === i ? 'w-6 bg-[#3f5d4e]' : 'w-2 bg-[#c3d1c7]'}`} data-id="element-136" data-mp="1ecvrycht1hz8" data-mpi={i} />)}
      </div>

      <div className="mt-5 flex flex-col items-center gap-1 px-5" data-id="element-137" data-mp="2kwq0w468aze1">
        <div className="flex" aria-hidden="true" data-id="element-138" data-mp="3hk33g3f4zqgi">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-[#e0a11a] text-[#e0a11a]" data-id="element-139" data-mp="3djauzce39pla" />)}
        </div>
        <span className="text-[15px] font-extrabold text-[#16302a]" data-id="element-140" data-mp="38rssul0bxiyq">4.9/5</span>
      </div>
    </section>;
}